import { render, staticRenderFns } from "./GjwForm.vue?vue&type=template&id=6574583c&scoped=true&"
import script from "./GjwForm.vue?vue&type=script&lang=js&"
export * from "./GjwForm.vue?vue&type=script&lang=js&"
import style0 from "./GjwForm.vue?vue&type=style&index=0&id=6574583c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6574583c",
  null
  
)

export default component.exports